import type { Enums } from "@msuite/utils/types";
import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";

/** Props Interface */
interface TimelineItemProps extends VariantProps<typeof timelineItem> {
	children: React.ReactNode;
}

export function TimelineItem({ children, state }: TimelineItemProps) {
	/** Classes */
	const classes = timelineItem({ state });

	/** Render */
	return (
		<div
			className={clsx("items-center gap-x-2 gap-y-1 grid grid-cols-2 card", classes)}
			style={{
				gridTemplateColumns: "max-content 1fr",
			}}
		>
			{children}
		</div>
	);
}

const timelineItem = cva([], {
	variants: {
		state: {
			published: [],
			editing: ["border-dashed opacity-80 shadow-none"],
			pending: ["border-dashed opacity-80 shadow-none"],
		} satisfies Record<Enums<"planState">, string[]>,
	},
	defaultVariants: {
		state: "published",
	},
});
